import axios from 'axios';
import { getAuthToken } from '@redpanda/utils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5007/api';
const IDENTITY_API_URL = process.env.REACT_APP_IDENTITY_SERVICE_URL || 'http://localhost:3000/api';
const SUBSCRIPTION_API_URL = process.env.REACT_APP_SUBSCRIPTION_SERVICE_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// 添加請求攔截器自動設定 Authorization header
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const identityApi = axios.create({
  baseURL: IDENTITY_API_URL,
  withCredentials: true,
});

identityApi.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const subscriptionApi = axios.create({
  baseURL: SUBSCRIPTION_API_URL,
  withCredentials: true,
});

subscriptionApi.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Queue Limit APIs (using subscription-service)
export const getQueueLimitInfo = () => {
  return subscriptionApi.get('/subscriptions/queue-limit');
};

// Queue Config APIs（需認證）
export const queueApi = {
  get: () => api.get('/queue'),
  update: (data: any) => api.patch('/queue', data),
  reset: () => api.post('/queue/reset'),
  toggleStatus: (isActive: boolean) => api.patch('/queue/status', { isActive }),
};

// Ticket APIs（需認證）
export const ticketApi = {
  getWaiting: () => api.get('/tickets/waiting'),
  create: (data: any) => api.post('/tickets', data),
  callNext: () => api.post('/tickets/call-next'),
  updateStatus: (id: string, status: string) => api.patch(`/tickets/${id}/status`, { status }),
  delete: (id: string) => api.delete(`/tickets/${id}`),
};

// Public APIs（不需認證）
export const publicApi = {
  getStatus: (storeId: string) => api.get(`/public/${storeId}/status`),
  takeNumber: (storeId: string, data: any) => api.post(`/public/${storeId}/take-number`, data),
  getTicket: (token: string) => api.get(`/public/ticket/${token}`),
  cancelTicket: (token: string) => api.post(`/public/ticket/${token}/cancel`),
};

// LINE APIs（需認證）
export const lineApi = {
  testPush: (lineUserId: string) => api.post('/line/test-push', { lineUserId }),
  verifyToken: (channelAccessToken: string) => api.post('/line/verify-token', { channelAccessToken }),
};

// LINE Public APIs（不需認證）
export const linePublicApi = {
  getLoginUrl: (storeId: string) => api.get(`/line/auth/url/${storeId}`),
};

// Analytics APIs（需認證）
export const analyticsApi = {
  today: () => api.get('/analytics/today'),
  history: (startDate: string, endDate: string) =>
    api.get('/analytics/history', { params: { startDate, endDate } }),
};

export default api;
